import "../index.css";
import { PropertyDetailsPageScreen } from "./property-details-screen.tsx";
import { reactHydrate } from "../react-hydrate.ts";
import { cleanTrackingParamsFromUrl } from "./url-cleanup.ts";

window.Components = {
  PropertyDetailsPageScreen: PropertyDetailsPageScreen,
};

cleanTrackingParamsFromUrl();

reactHydrate();
